import { render, staticRenderFns } from "./propertiesSec.vue?vue&type=template&id=211feeb8&scoped=true&"
import script from "./propertiesSec.vue?vue&type=script&lang=js&"
export * from "./propertiesSec.vue?vue&type=script&lang=js&"
import style0 from "./propertiesSec.vue?vue&type=style&index=0&id=211feeb8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211feeb8",
  null
  
)

export default component.exports